import globalConfirmation from "live/services/global-confirmation";
import i18n from "live/services/i18n";
import { fetchApi } from "../api/fetchApi";
import { getFiles } from "../api/getFiles";

export const deleteFile = (file, setFiles) => {
  globalConfirmation.danger(
    i18n("Are you sure you want to delete this file?"),
    i18n("This file will be permanently deleted from Live"),
    () => deleteF()
  );

  const deleteF = () => {
    fetchApi("DELETE", `/services/plugin-upload/delete/${file.uuid}`)
      .then((response) => {
        if (response.ok) getFiles(setFiles);
      })
      .catch((err) => console.warn("Fetch error: ", err));
  };
};

export const deleteFileByDirectory = (file, setFiles, directory = null) => {
  globalConfirmation.danger(
    i18n("Are you sure you want to delete this file?"),
    i18n("This file will be permanently deleted from Live"),
    () => deleteF()
  );

  const deleteF = () => {
    fetchApi("DELETE", `/services/plugin-upload/delete/${directory ? `${directory}/` : ''}${file.uuid}`)
      .then((response) => {
        if (response.ok) setFiles();
      })
      .catch((err) => console.warn("Fetch error: ", err));
  };
};
